export default () => {
  const url = process.env.REACT_APP_URL || 'http://localhost:3000';
  window.localStorage.removeItem('token');
  window.location.href = `${
    process.env.REACT_APP_API_URL
  }/logout?redirect_to=${encodeURI(url)}`;
};
